<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="qualificationForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                qualificationForm: () => import('../forms/QualificationForm'),
                headers: [
                    { text: 'Staff Member', value: 'staffMemberId', table: 'staffMembers', form: () => import('../forms/StaffMemberForm') },
                    { text: 'Name', value: 'name' },
                    { text: 'File', value: 'fileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    files: [],
                    staffMembers: [],
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                    { column: "staffMemberId", direction: "ascending" },
                ],
                itemsField: 'qualifications',
                editPageName: 'qualification',
                apiMethod: 'Qualifications',
                claimName: 'Qualifications',
                formTitle: 'Qualification',
                excelTitle: 'Qualifications',
                hasEditPage: false,
            }
        },
    };
</script>
